export default "__VITE_ASSET__BTmtPXYG__"